import { render, staticRenderFns } from "./SenderId.vue?vue&type=template&id=7010d275&"
import script from "./SenderId.vue?vue&type=script&lang=js&"
export * from "./SenderId.vue?vue&type=script&lang=js&"
import style0 from "./SenderId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports